// extracted by mini-css-extract-plugin
export default {"main":"CatalogCategoryPage_main__BC1zw","header":"CatalogCategoryPage_header__0wkJw","title_block":"CatalogCategoryPage_title_block__27mcH"};